var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider} from '@material-ui/core/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import PositionsDialog from '../CreateDialogue/PositionsDialog';
import EditPositionsDialog from '../EditDialogue/EditPositionsDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import {logger, customBodyForExcelReport,handleExport,permissions,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');


export default function PositionsTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [positions, setPositions] = React.useState([]);
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(true);

    const handleDialogCallback = (childData) => {
        fetch("api/position", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "position": [{
                    "Name": childData.Name,
                    "CommonName": childData.CommonName,
                    "IsActive": childData.IsActive
                }]
            })
        }).then(res => res.json()
        ).then(json => {
            if (json.code == 'ER_DUP_ENTRY') {
                setAlertText(json.message)
                setAlert(true)
            }
        })

        logger(childData);
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {
        fetch("api/position", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "position": {
                    "Name": childData.Name,
                    "CommonName": childData.CommonName,
                    "IsActive": childData.IsActive,
                    "ID": childData.ID
                }
            })
        }).then(res => res.json()
        ).then(json => {
			if (json.code == 'ER_DUP_ENTRY') {
				setAlertText(json.message)
				setAlert(true)
			}
		})
        logger(childData);
        setRefresh(true);
    };

    const handleAlertClose = () => {
        setAlert(false);
    };

    React.useEffect(() => {
        if (refresh) {
            fetch('api/position', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setPositions(json);
					setIsLoading(false);
				})

            setRefresh(false);
        }
    })
    
	const columns = [];
	if (permissions.CreatePosition == 1) {
		const adminActions = {
			name: "Admin Actions",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRenderLite: (dataIndex, rowIndex) => {
					return (
						<div>
							<EditPositionsDialog handleEditCallback={handleEditCallback} data={positions[dataIndex]} />
						</div>
					);
				}

			}
		};
        columns.push(adminActions);
	}
	
	const columns1 = [
        {
            name: "Name",
            label: "Long Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "CommonName",
            label: "Name",
            options: {
                filter: true,
                sort: true,
            }
        },
		{
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: true,
                filterList: ['Active'],
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                        	{(positions[dataIndex].IsActive === 'Active') ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                }
            }
		}	
	];
	
	columns.push(...columns1);

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('PositionrowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('PositionrowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

	const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
        onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'Position.xlsx', columnIndexToRemove:0})
			return false;
		}
    };
    
   if(permissions.CreatePosition == 1 && !isLoading ){
	    const addPositionDialog = ()=> (<PositionsDialog handleDialogCallback={handleDialogCallback} />);
	    options.customToolbar = addPositionDialog;
    }

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (       
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="PositionsTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Position
                        </Typography>
                    }
                    data={isLoading ? [] :positions}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
            <Dialog
                open={LockedAlert}
                onClose={handleAlertClose}
                aria-labelledby="L&P Lock"
                aria-describedby="Time Period locked for this work"
            >
                <DialogTitle id="Position">
                    {"Alert"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {AlertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
        
    );
} 
   